import { Modal } from 'react-bootstrap';
import AlarmIcon from 'assets/img/popup/Alarm.svg';

interface Props {
  show: boolean;
  handleSubmit: () => void;
}

const QuizExpiredModal = ({ show, handleSubmit }: Props) => {
  return (
    <Modal show={show} onHide={handleSubmit} className="p-0" centered size="sm">
      <Modal.Body className="pt-4 pb-2 px-4">
        <div className="d-flex justify-content-center mb-2">
          <img src={AlarmIcon} width={100} />
        </div>
        <h5 className="text-center fs-6">
          Oops! <br />
          Time's Up!
        </h5>
        <p className="mt-3 text-center">
          Expired! Answers submitted automatically.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default QuizExpiredModal;
